module.exports = __webpack_public_path__ + "img/TRUEWALLET.6a8ee9a2.png";